import { render, staticRenderFns } from "./MinicartItem.vue?vue&type=template&id=083b6ac5"
import script from "./MinicartItem.vue?vue&type=script&lang=js"
export * from "./MinicartItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports